const bannerdata = [
    {
        id: 1,
        image: '../images/banner-1.jpg',
        altdata: 'Image'
    },
    {
        id: 2,
        image: '../images/banner-2.jpg',
        altdata: 'Image'
    },
    {
        id: 3,
        image: '../images/banner-3.jpg',
        altdata: 'Image'
    },
    {
        id: 4,
        image: '../images/banner-4.jpg',
        altdata: 'Image'
    },
  ];

const ItemData = [
    {
        id: 1,
        image: '../images/frame-img-1.jpeg',
        title: 'Vincent Chase',
        size: 'Wide',
        type: 'Gradient',
        price: '98',
        color1: 'content-box content-box #c0c0c0',
        color2: 'content-box content-box #ffd703',
        color3: 'content-box content-box #b87332',
        offer: 'Extra 25% Off. Coupon: S25'
    },
    {
        id: 2,
        image: '../images/frame-img-2.jpeg',
        title: 'Vincent Chase',
        size: 'Narrow',
        type: 'Shine On',
        price: '199',
        color1: 'content-box content-box #c0c0c0',
        color2: 'content-box content-box #ffd703',
        color3: 'content-box content-box #b87332',
        offer: 'Extra 25% Off. Coupon: S25'
    },
    {
        id: 3,
        image: '../images/frame-img-3.jpeg',
        title: 'Vincent Chase',
        size: 'Medium',
        type: 'Fit For Progressive',
        price: '299',
        color1: 'content-box content-box #c0c0c0',
        color2: 'content-box content-box #ffd703',
        color3: 'content-box content-box #b87332',
        offer: 'Extra 25% Off. Coupon: S25'
    },
    {
        id: 4,
        image: '../images/frame-img-3.jpeg',
        title: 'Vincent Chase',
        size: 'Wide',
        type: 'Gradient',
        price: '98',
        color1: 'content-box content-box #c0c0c0',
        color2: 'content-box content-box #ffd703',
        color3: 'content-box content-box #b87332',
        offer: 'Extra 25% Off. Coupon: S25'
    },
    {
        id: 5,
        image: '../images/frame-img-1.jpeg',
        title: 'Vincent Chase',
        size: 'Narrow',
        type: 'Shine On',
        price: '199',
        color1: 'content-box content-box #c0c0c0',
        color2: 'content-box content-box #ffd703',
        color3: 'content-box content-box #b87332',
        offer: 'Extra 25% Off. Coupon: S25'
    },
    {
        id: 6,
        image: '../images/frame-img-2.jpeg',
        title: 'Vincent Chase',
        size: 'Medium',
        type: 'Fit For Progressive',
        price: '299',
        color1: 'content-box content-box #c0c0c0',
        color2: 'content-box content-box #ffd703',
        color3: 'content-box content-box #b87332',
        offer: 'Extra 25% Off. Coupon: S25'
    },
  ];
export { bannerdata, ItemData };